// bounty, relativity, rubicon
import {setText} from '@acng/frontend-bounty';
import {
  HTMLElement,
  connectedCallback,
  defineElement,
  disconnectedCallback,
} from '@acng/frontend-bounty/dom/custom.js';
import {CTX_OBSERVE} from '@acng/frontend-relativity/minify';
import {guard} from '@acng/frontend-rubicon';
// enterprise
import {listen} from 'acng/core/context/event-bus.js';
import {ctxAuthUser} from 'acng/userPool/context/auth-user.js';
import {EVENTBUS_USER} from '../../user/model/user-data.js';

const MODULE = 'payment/element/coin-amount';

defineElement(
  'payment-coin-amount',
  class extends HTMLElement {
    /**
     * @type {(() => void) | undefined}
     */
    #unreg;

    [connectedCallback]() {
      ctxAuthUser[CTX_OBSERVE](this, (authUser) => {
        setText(this, `${authUser?.coins ?? ''}`);
      });
      this.#unreg = listen('user', (data) => {
        ASSERT: guard(data, EVENTBUS_USER);
        setText(this, `${data.user.coins}`);
      });
    }

    [disconnectedCallback]() {
      this.#unreg?.();
    }
  }
);
